// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-065ea82d] .el-form-item__label {\n}\n[data-v-065ea82d] .el-form-item__content {\n  background-color: rgba(245, 245, 245, 1);\n  padding: 0 20px;\n}\n", ""]);
